<template>
    <div class="page" v-show="bodyShow">
        <div class="cover">
            <van-image
                fit="cover"
                height="210"
                width="100%"
                :src="detail.cover_url"
            />
            <div  class="shade"></div>
            <div class="grade" @click="bindToReport">
              <span class="iconfont iconjiangbei mr5"></span>
              <span style="color: #ffca05;letter-spacing: 1px;" >{{detail.scores}}分</span>
            </div>
            <div class="phase_name" @click="bindToTrain">
              <div class="phase_name_train">{{detail.train_name}}</div>
              <div  class="phase_name_icon"><span class="iconfont iconxiayiye mr5"></span></div>
            </div>
            <div class="train-user" @click="bindToStudents">
                <div class="train-user-logo">
                    <img :class="'train-user-img '+(index >0?'mlf15':'')" v-for="(item,index) in detail.stage_enter_users" :key="index"
                            :src="item.photo"/>
                </div>
                <div class="train-user-col">
                    <template v-if="detail.stage_enter_users_cnt>5">
                      等{{detail.stage_enter_users_cnt}}人参与
                    </template>
                    <template v-else-if="detail.stage_enter_users_cnt<5 && detail.stage_enter_users_cnt > 0">
                      {{detail.stage_enter_users_cnt}}人参与
                    </template>
                    <template v-else >
                      暂无人参与
                    </template>
                </div>
                <div  class="train-user-icon"><span class="iconfont iconxiayiye mr5"></span></div>
            </div>
        </div>
        <div class="task">
          <div  v-for="(item,index) in detail.tasks" :key="index"  class="task-item" @click="bindActiveTask(item, index)" >
              <div class="task-item-top" :class="item.active?'task-item-top-active':''" >{{index+1}}</div>
              <div class="task-item-day">{{item.name}}</div>
              <div class="task-item-status">
                  <template v-if="item.lock==1"> 
                    未解锁
                  </template>
                  <template v-else > 
                    {{item.status==1?'已完成':'未完成'}}
                  </template>
              </div>
          </div>
        </div>
        <div class="detail">
          <div v-for="(item,index) in task_detail" :key="item.training_study_content_id" class="detail-item">
              <div class="detail-bar">
                <div class="detail-bar-icon">
                    {{task_type_cn[item.object_type]}}
                </div>
                <div class="detail-bar-line-content">
                  <div class="detail-bar-line"></div>
                </div>
                <div class="detail-bar-line-direction" >
                  <span v-if="(index+1)!=task_detail.length" class="iconfont iconxiala mr5"></span>
                  <span v-if="(index+1)==task_detail.length" class="iconfont iconjieshu1 mr5"></span>
                </div>
              </div>
              <div class="detail-task" >
                <div class="detail-task-title" @click="bindToStudy(item)">{{item.name}}</div>
                <div class="detail-task-content">
                  <van-image
                      v-if="item.object_info && item.object_info.cover_url"
                      fit="cover"
                      height="150"
                      width="100%"
                      @click="bindToStudy(item)"
                      :src="item.object_info.cover_url"
                  />
                  <div class="detail-task-content-text" @click="bindToStudy(item)" >{{item.content}}</div>
                </div>
                <div class="detail-task-op">
                    <!-- 课程 -->
                    <div v-if="item.object_type==2"   :key="index" class="detail-task-op-course">
                      <template v-for="(course_item, course_index) in item.object_info.sections" >
                        <div :key="course_index" class="course-item" @click="bindToCurriculum(course_item, item)" >
                            <div class="course-item-name font-size-12">【章节】{{course_item.name}}</div>
                            <div class="course-item-status font-size-12">{{course_item.rate_cn}}</div>
                        </div>
                      </template>
                    </div>

                    <!-- 直播 -->
                    <div v-if="item.object_type==6"   :key="index" class="detail-task-op-cus">
                      <div class="cus-item-name font-size-12">直播时长：{{item.object_info.live_long}}分钟</div>
                      <div v-if="item.object_info.live_start_status==0" @click="bindToLive(item)" class="cus-item-op font-size-12">未开始</div>
                      <div v-if="item.object_info.live_start_status==1" @click="bindToLive(item)" class="cus-item-op font-size-12">去观看</div>
                      <div v-if="item.object_info.live_start_status==2" @click="bindToLive(item)" class="cus-item-op font-size-12">已结束</div>
                    </div>

                    <!-- 考试 -->
                    <div v-if="item.object_type==5"   :key="index" class="detail-task-op-cus">
                      <div class="cus-item-name font-size-12">总分：{{item.object_info.score}}分</div>
                      <div class="cus-item-name font-size-12">
                        <template v-if="item.object_info.limit_duration>0">
                          时长：{{item.object_info.limit_duration}}分钟
                        </template>
                        <template v-if="item.object_info.limit_duration==0">
                          时长：不限时
                        </template>
                      </div>
                      <div class="cus-item-op font-size-12" @click="bindToTesting(item)" >
                        <template v-if="item.object_info.status==0">
                          去考试
                        </template>
                        <template v-if="item.object_info.status==1">
                          去查看
                        </template>
                      </div>
                    </div>

                    <!-- 练习 -->
                    <div v-if="item.object_type==4"   :key="index" class="detail-task-op-cus" @click="bindToExercise(item)" >
                      <div class="cus-item-name font-size-12">总分：{{item.object_info.score}}分</div>
                      <div class="cus-item-name font-size-12"> 题目：{{item.object_info.question_num}}个</div>
                      <div v-if="item.object_info.status==0" class="cus-item-op font-size-12">去练习</div>
                      <div v-if="item.object_info.status==1" class="cus-item-op font-size-12">去查看</div>
                    </div>

                    <!-- 内容 -->
                    <div v-if="item.object_type==1"   :key="index" class="detail-task-op-cus">
                      <van-image
                          v-if="item.object_info.image_url"
                          fit="cover"
                          width="100%"
                          :src="item.object_info.image_url"
                      />
                    </div>
                </div>
              </div>
          </div>
          <div class="lock" v-if="lock_status==1">
            <span  class="iconfont iconsuo mr5"></span>
          </div>
        </div>
    </div>
</template>

<script>
import {Image as VanImage,Divider,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
export default {
    name: "phase",
    components:{
      [VanImage.name]:VanImage,
    },
    data(){
        return {
          bodyShow:false,
          training_id: '',
          training_stage_id: '',
          lock_status: 0,
          detail: {
              cover_url: "https://img.fincgo.com/mall/2/20201028/64/5f9939c212a46.jpg",
              stage_enter_users_cnt: 5,
              stage_enter_users: [
                  {
                      "user_id":"25488",
                      "photo":"https://o-yzx.bysjy.com.cn/notice/1596594279-5941.cn/mmopen/vi_32/BTiaVJMOFUdicLkuvOpbftCl1QHibnHuuTn3Ewod3rfVwHmBcibkhrvmOIiaRMYzXaFgzcGLHsnBaYLDwuahxmn45uw/132"
                  },
              ],
              
              content: "<img src='https://img.fincgo.com/mall/0/20201028/12/5f993ce779757.jpg' /><img src='https://img.fincgo.com/mall/0/20201028/7/5f993d067c27f.jpg' />"
          },
          task_detail:[],
          task_type_cn:[
            "",
            "内容",//1
            "课程",//2
            "作业",//3
            "练习",//4
            "考试",//5
            "直播",//6
          ],
          curIndex: 0
        }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 通过 `vm` 访问组件实例
        const { curIndex } = from.query
        if (curIndex) {
          vm.curIndex = curIndex ? parseInt(curIndex) : 0
          vm.get_stage_detail()
        }
      })
    },
    mounted(){
        this.util.hideOptionMenu()
        this.init()
        this.$(document).attr('title','营期')
        this.training_stage_id = this.$route.query.stage_id
        this.get_stage_detail()
    },
    methods:{
      init(){
        
      },
      get_stage_detail(){
        var _self=this;
        this.util.server.mini_training.get_stage_detail({
            data:{
                training_stage_id: this.training_stage_id,
            },
            callback:(res => {
                _self.bodyShow = true
                console.log(res)
                if(res.data){
                  let datas = res.data
                  this.$(document).attr('title',datas.name)
                  _self.training_id = datas.training_id
                  _self.detail = datas

                  console.log('datas',datas)
                  if(!datas.stage_is_own){
                    Dialog.confirm({
                        title: '系统提示',
                        message: '您暂未加入当前营期, 一起与同学们互动吧',
                        confirmButtonText: '前往训练营',
                        showCancelButton:false
                    })
                    .then((res) => {
                        _self.$router.push(_self.util.urlPrefix+'/training/index?training_id='+_self.training_id+'&token='+_self.util.token);
                    })
                  }

                  if(datas.tasks.length > 0){
                    console.log(datas.tasks)
                    _self.get_tasks(datas.tasks[this.curIndex].training_task_id, datas.tasks[this.curIndex].lock)
                  }
                  
                }
            })
        })
      },
      activeTask (training_task_id) {
        console.log('11',this.detail)
        this.detail.tasks.forEach((element, index) => {
          element.active = 0
          if(element.training_task_id == training_task_id){
            element.active = 1
          }
        });
      },
      get_tasks(training_task_id,lock_status){
        var _self=this
        _self.activeTask(training_task_id)
        _self.lock_status = lock_status
        this.util.server.mini_training.get_tasks({
            data:{
                training_task_id: training_task_id,
            },
            callback:(res => {
                console.log(res)
                let datas = res.data
                _self.task_detail = datas
                
            })
        })
      },
      bindActiveTask(items, index){
        this.curIndex = index
        this.get_tasks(items.training_task_id, items.lock)
      },
      bindToTrain(){
        this.$router.push(this.util.urlPrefix+'/training/index?training_id='+this.training_id+'&token='+this.util.token)
      },
      bindToStudents(){
        this.$router.push(this.util.urlPrefix+'/training/students?stage_id='+this.training_stage_id+'&type=1&token='+this.util.token)
      },
      bindToReport(){
        this.$router.push(this.util.urlPrefix+'/training/report?stage_id='+this.training_stage_id+'&token='+this.util.token)
      },
      bindToStudy(item){
        console.log(item)
        if(item.object_type==2){//课程
          this.bindToCourse(item)
        }else if(item.object_type==6){//直播
          this.bindToLive(item)
        }else if(item.object_type==5){//考试
          this.bindToTesting(item)
        }else if(item.object_type==4){//练习
          this.bindToExercise(item)
        }
      },
      bindToLive(item){
        console.log('bindToLive',item)
        //return
        let course_id = item.object_id
        let study_id = item.training_study_content_id
        this.$router.push(this.util.urlPrefix+'/training/live?study_id='+study_id+'&course_id='+course_id+'&token='+this.util.token+'&curIndex='+this.curIndex)
      },
      bindToTesting(item){
        let test_id = item.object_id
        let study_id = item.training_study_content_id
        console.log('item',item)
        if(item.object_info.status==1){
          this.$router.push(this.util.urlPrefix+'/training/answered?test_id='+test_id+'&study_id='+study_id+'&token='+this.util.token+'&curIndex='+this.curIndex)
        }else{
          this.$router.push(this.util.urlPrefix+'/training/testing?test_id='+test_id+'&study_id='+study_id+'&token='+this.util.token+'&curIndex='+this.curIndex)
        }
        
      },
      bindToCurriculum(item,pitem){
        let course_id = item.course_id
        let study_id = pitem.training_study_content_id
        let sections_id = item.sections_id
        this.$router.push(this.util.urlPrefix+'/training/curriculum?course_id='+course_id+'&study_id='+study_id+'&currents='+sections_id+'&token='+this.util.token+'&curIndex='+this.curIndex)
      },
      bindToExercise(item){
        console.log('练习',item)
        let practice_id = item.object_id
        let study_id = item.training_study_content_id
        this.$router.push(this.util.urlPrefix+'/training/exercise?practice_id='+practice_id+'&study_id='+study_id+'&token='+this.util.token+'&curIndex='+this.curIndex)
      },
      bindToCourse(item){
        let course_id = item.object_id
        let study_id = item.training_study_content_id
        this.$router.push(this.util.urlPrefix+'/training/curriculum?course_id='+course_id+'&study_id='+study_id+'&token='+this.util.token+'&curIndex='+this.curIndex)
      },
    }
  }
</script>
<style scoped>
.cover{
  position: relative;
  overflow: hidden;
}
.shade{
    position: absolute;
    color: #FFF;
    top: 0px;
    height: 100px;
    width: 100%;
    font-weight: 600;

    position: absolute;
    color: #FFF;
    top: -34px;
    height: 22.25rem;
    width: 100%;
    font-weight: 600;
    /* opacity: 0.5; */
    background: rgba(6, 6, 6, 0.7);
    
    transform: rotate(-57deg);
    left: 178px;
    overflow: hidden;
}
.phase_name{
    position: absolute;
    color: #e8e6e6;
    top: 0px;
    right: 0;
    width: 135px;
    height: 28px;
    line-height: 28px;
    padding: 5px;
    border-radius: 15px 0px 0px 15px;
    display: flex;

}

.phase_name_train{
    flex: 1;
    text-align: right;
    overflow: hidden;
}
.phase_name_icon{
    /* width: 25px; */

}
.phase_name .iconxiayiye{
    vertical-align: middle;
}
.van-image{
    display: block;
}
.task{
    background-color: #FFF;
    padding: 15px;
    white-space: nowrap;
    overflow-y: scroll;
}
.task::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  display: none;
}
.task-item{
    width: 70px;
    text-align: center;
    display: inline-block;
}
.task-item-top{
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background: orange;
    text-align: center;
    line-height: 30px;
    color: #FFF;
    display: inline-block;
}
.task-item-day{
    margin-top: 5px;
    font-size: 12px;
    letter-spacing: 1px;
    color: #999999;
    overflow: hidden;
}
.task-item-status{
    margin-top: 2px;
    font-size: 11px;
    transform: scale(0.9);
    color: #ccc;
}

.train-user{
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;

}
.train-user-logo{
    padding-top: 13px;
    margin-right: 15px;
}
.train-user-img{
    width: 25px;
    border-radius: 50%;
}
.train-user-col{
    font-size: 12px;
    color: #FFF;
    line-height: 55px;
    height: 55px;
    letter-spacing: 1px;
}
.train-user-icon{
    line-height: 55px;
    height: 55px;
    color: #FFF;
    margin-right: 5px;
}
.mlf15{
    margin-left: -12.5px;
}
.grade{
    position: absolute;
    top: 85px;
    right: 40px;
    width: 100px;
}
.grade .iconjiangbei{
    font-size: 40px;
    color: #ffca05;
}
.detail{
    padding: 15px 15px 40px;
    position: relative;
    min-height: calc(100vh - 363px);
}
.detail-item{
    display: flex;
    padding-bottom: 8px;
}
.detail-bar{
    width: 30px;
    display: flex;
    flex-direction: column;
}
.detail-bar-icon{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: orange;
    line-height: 30px;
    font-size: 11px;
    text-align: center;
    color: #FFF;
}
.detail-task{
    flex: 1;
    padding-left: 10px;
}
.detail-bar-line{
    height: 100%;
    width: 1px;
    background-color: orange;
    display: inline-block;
}
.detail-bar-line-content{
    flex: 1;
    text-align: center;
}
.detail-bar-line-direction{
    height: 20px;
    text-align: center;
}
.detail-bar-line-direction .iconxiala{
    font-size: 18px;
    color: #f14604;
}
.detail-bar-line-direction .iconjieshu1{
    font-size: 18px;
    color: #f14604;
}

.detail-task-title{
    line-height: 30px;
    font-weight: 600;
    font-size: 16px;
}
.detail-task-content-text{
    font-size: 15px;
    padding: 5px 0px 5px 0px;
    color: #999999;
    letter-spacing: 2px;
    line-height: 18px;
}
.detail-task-op{
    padding-bottom: 20px;
    padding-top: 4px;
}
.lock{
  position:absolute;
  /* background: rgba(255, 165, 1, 0.7); */
  /* background: linear-gradient(top left, white, blue); */
  /* background: -webkit-linear-gradient(top left, white, orange); */
  background: -webkit-radial-gradient(circle,rgba(36, 36, 34, 1),rgba(0,0,0,0));
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.lock .iconsuo{
  position: absolute;
  /* top: 100px;
  left: calc(50vw - 20px); */
  top: 50%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
  font-size: 55px;
  color: orange;
}
.course-item{
    display: flex;
    justify-content: space-between;
    padding: 5px 0px;
    
}
.course-item-name{
    overflow: hidden;
    width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #777070;
}
.course-item-status{
    width: 50px;
    color: #ffa500;
    text-align: right;
}
.detail-task-op-cus{
    display: flex;
    justify-content: space-between;
}
.cus-item-name{
    color: #777070;
    line-height: 20px;
    height: 20px;
}
.cus-item-op{
    color: #FFF;
    background-color: #ffa500;
    padding: 2px 5px;
}
.font-size-12{
    font-size: 14px;
}
.task-item-top-active{
  background-color: red;
}
.detail-task-content >>> .van-image{
  margin-top: 10px;
}

</style>